import CIMSTable from 'components/CIMSTable'
import { useRoutingGroupsTableContext } from '../../RoutingGroupsTableContext'
import { useColumns } from './hooks/useColumns'
import { useCreateOptions } from './hooks/useCreateOptions'
import { useEditOptions } from './hooks/useEditOptions'
import { useExpandOptions } from './hooks/useExpandOptions'
import { useRemoveOptions } from './hooks/useRemoveOptions'
import { HelpMessage } from 'utils/constants'
import { useRestoreOptions } from './hooks/useRestoreOptions'

export const RoutingGroupsTable: React.FC = () => {
  const { records, refetch, fetching } = useRoutingGroupsTableContext()
  return (
    <CIMSTable
      rowKey={'id'}
      loading={fetching}
      records={records}
      columns={useColumns()}
      details={HelpMessage.CAS.RoutingGroups.Details}
      actions={{
        header: {
          create: useCreateOptions(),
          onReload: refetch,
        },
        row: {
          edit: useEditOptions(),
          remove: useRemoveOptions(),
          restore: useRestoreOptions(),
        },
      }}
      expand={useExpandOptions()}
    />
  )
}
